var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRestaurantes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Restaurantes",
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.998,
    height: 58.981,
    viewBox: "0 0 58.998 58.981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #002353;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    className: "cls-1",
    d: "M11.07,13.519h2.07V1.508c0-.83.233-1.513,1.166-1.506s1.166.7,1.154,1.527c0,4.607.035,9.214-.03,13.821a6.609,6.609,0,0,1-3.369,5.808,1.657,1.657,0,0,0-.886,1.655q.033,15.774,0,31.556a11.483,11.483,0,0,1-.084,1.723,3.42,3.42,0,0,1-6.733.093,8.766,8.766,0,0,1-.11-1.6q0-15.951.016-31.9a1.462,1.462,0,0,0-.8-1.464A6.817,6.817,0,0,1,.012,15.1C0,10.61.012,6.12,0,1.629,0,.776.152,0,1.166,0S2.331.79,2.32,1.629V13.456H4.383V1.883c0-.87-.042-1.865,1.14-1.865S6.705.962,6.689,1.853V13.512h2.07V1.352c0-.809.35-1.38,1.205-1.355.788.026,1.105.59,1.1,1.343V13.519ZM2.4,15.921A4.287,4.287,0,0,0,5.1,19.453a2.089,2.089,0,0,1,1.515,2.331Q6.554,38.13,6.586,54.475c0,.886-.247,1.979,1.1,2.152.851.11,1.187-.553,1.187-2.182q0-16.346-.016-32.691a2,2,0,0,1,1.427-2.264,4.353,4.353,0,0,0,2.772-3.569Z",
    transform: "translate(0 0.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    className: "cls-1",
    d: "M217.236,28.849V55.441c0,2.772-2.432,4.542-4.8,3.5a3.408,3.408,0,0,1-2.112-3.392c0-5.129-.026-10.284.023-15.425a2.83,2.83,0,0,0-.963-2.3,10.021,10.021,0,0,1-2.1-2.42,7.267,7.267,0,0,1-.853-3.157c-.082-5.1-.14-10.209,0-15.31A19.889,19.889,0,0,1,214.984.774c.406-.3,1.194-.562,1.518-.366a1.973,1.973,0,0,1,.7,1.5C217.248,10.89,217.236,19.868,217.236,28.849Zm-2.308-25.06c-.434.38-.674.564-.884.779a17.826,17.826,0,0,0-5.313,12.5c-.077,4.108-.019,8.218,0,12.326,0,4.791-.417,4.129,3.073,7.652a3.14,3.14,0,0,1,.8,2c.065,5.26.035,10.522.037,15.781,0,.345-.117.783.049,1.016.3.417.741.933,1.166.979.317.035.753-.578,1.042-.972.131-.175.033-.52.033-.79V14.741Z",
    transform: "translate(-158.24 -0.26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    className: "cls-1",
    d: "M89.072,72.56A16.362,16.362,0,1,1,72.736,56.24,16.362,16.362,0,0,1,89.072,72.56ZM72.731,86.646A14.054,14.054,0,1,0,58.659,72.582,14.054,14.054,0,0,0,72.731,86.646Z",
    transform: "translate(-43.211 -43.127)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    className: "cls-1",
    d: "M86.151,187.137a22.706,22.706,0,0,1-11.867-3.15c-.7-.424-1.5-.881-.933-1.865s1.341-.615,2.068-.14c.161.1.326.2.494.294a19.573,19.573,0,0,0,18.241.585,18.558,18.558,0,0,0,6.195-4.691c.18-.2.357-.4.527-.609.527-.643,1.142-.989,1.865-.338.655.592.42,1.224-.077,1.823a21.657,21.657,0,0,1-13.1,7.712C88.247,186.992,86.9,187.055,86.151,187.137Z",
    transform: "translate(-56.102 -135.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    className: "cls-1",
    d: "M92.641,32a21.428,21.428,0,0,1,14.417,6.295c.168.159.331.322.483.5a1.154,1.154,0,1,1-1.6,1.662c-.147-.124-.277-.266-.415-.4A19.582,19.582,0,0,0,83.184,36.2l-.315.142c-.678.3-1.31.287-1.681-.434-.41-.8.028-1.322.723-1.665A22.967,22.967,0,0,1,92.641,32Z",
    transform: "translate(-62.139 -24.538)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    className: "cls-1",
    d: "M60.882,186.429c-.445.284-.933.844-1.327.779-.436-.07-.781-.7-1.166-1.091.389-.382.748-1.028,1.166-1.075s.877.539,1.317.846Z",
    transform: "translate(-44.777 -141.898)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    className: "cls-1",
    d: "M81.03,93.55a10.6,10.6,0,0,1,6.1-9.092c.753-.378,1.452-.385,1.837.466.368.821-.147,1.273-.832,1.616a8.211,8.211,0,0,0-4.772,7.2c-.061.844-.338,1.49-1.261,1.417S80.972,94.375,81.03,93.55Z",
    transform: "translate(-62.132 -64.579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    className: "cls-1",
    d: "M124.058,82.574c-.45.291-.872.758-1.355.835a.9.9,0,0,1-1.089-1.093,1.7,1.7,0,0,1,1.112-1.084c.413-.047.886.52,1.331.818Z",
    transform: "translate(-93.24 -62.29)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurantes);
export default __webpack_public_path__ + "static/media/Restaurantes.da662f740b3d3f8a65fdd163d98afb84.svg";
export { ForwardRef as ReactComponent };